import React from 'react';
import { __ } from '../../Lang.js';
import CancelIcon from '@mui/icons-material/Cancel';
import Link from '@mui/material/Link';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';

const FilterControls = ({
  filterActive,
  onFilterClick,
  isSATMode,
  selectedYear,
  availableYears,
  onYearChange,
  filtersAreInUse
}) => {

const getValue = (group) => {
  if (group === 'presenter') {
    if (filterActive.johnroger) return 'johnroger';
    if (filterActive.johnmorton) return 'johnmorton';
    if (filterActive.presenter) return filterActive.presenter;
    return 'presenterAll';
  }

  if (group === 'asset_type') {
    if (filterActive.audio) return 'audio';
    if (filterActive.video) return 'video';
    if (filterActive.asset_type) return filterActive.asset_type;
    return 'all';
  }

  if (group === 'usage_type') {
    if (filterActive.public) return 'public';
    if (filterActive.personal) return 'personal';
    if (filterActive.minister) return 'minister';
    if (filterActive.initiate) return 'initiate';
    if (filterActive.usage_type) return filterActive.usage_type;
    return 'usageAll';
  }

  if (group === 'access') {
    if (filterActive.premium) return 'premium';
    if (filterActive.open) return 'open';
    if (filterActive.access) return filterActive.access;
    return 'accessAll';
  }

  return '';
};

  return (
    <div className="filter-controls">
      <div className="filter-controls__container dropdown-mode">


        {/* PRESENTER */}
        <FormControl className="filter-controls__group" size="small">
          <InputLabel sx={{ fontWeight: 600, color: '#444', fontSize: '0.85rem' }}>{__('PRESENTER')}</InputLabel>
          <Select
            value={getValue('presenter')}
            label={__('PRESENTER')}
            onChange={(e) => onFilterClick(e.target.value)}
            sx={{
              fontSize: '0.85rem',
              borderRadius: '6px',
              minWidth: '120px',
              maxWidth: '180px',
              '& .MuiOutlinedInput-notchedOutline': { borderColor: '#ccc' },
              '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#ccc' },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#7f3fbf' },
            }}
          >
            <MenuItem value="presenterAll">{__('All')}</MenuItem>
            <MenuItem value="johnroger">John-Roger</MenuItem>
            <MenuItem value="johnmorton">John Morton</MenuItem>
          </Select>
        </FormControl>

        <FormControl className="filter-controls__group" size="small">
          <InputLabel sx={{ fontWeight: 600, color: '#444', fontSize: '0.85rem' }}>{__('CONTENT TYPE')}</InputLabel>
          <Select
            value={getValue('asset_type')}
            label={__('CONTENT TYPE')}
            onChange={(e) => onFilterClick(e.target.value)}
            sx={{
              fontSize: '0.85rem',
              borderRadius: '6px',
              minWidth: '120px',
              maxWidth: '180px',
              '& .MuiOutlinedInput-notchedOutline': { borderColor: '#ccc' },
              '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#ccc' },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#7f3fbf' },
            }}
          >
            <MenuItem value="all">{__('All')}</MenuItem>
            <MenuItem value="audio">{__('Audio')}</MenuItem>
            <MenuItem value="video">{__('Video')}</MenuItem>
          </Select>
        </FormControl>

        <FormControl className="filter-controls__group" size="small">
          <InputLabel sx={{ fontWeight: 600, color: '#444', fontSize: '0.85rem' }}>{__('USAGE TYPE')}</InputLabel>
          <Select
            value={getValue('usage_type')}
            label={__('USAGE TYPE')}
            onChange={(e) => onFilterClick(e.target.value)}
            sx={{
              fontSize: '0.85rem',
              borderRadius: '6px',
              minWidth: '120px',
              maxWidth: '180px',
              '& .MuiOutlinedInput-notchedOutline': { borderColor: '#ccc' },
              '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#ccc' },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#7f3fbf' },
            }}
          >
            <MenuItem value="usageAll">{__('All')}</MenuItem>
            <MenuItem value="public">{__('Public')}</MenuItem>
            <MenuItem value="personal">{__('Personal')}</MenuItem>
            <MenuItem value="minister">{__('Minister')}</MenuItem>
            <MenuItem value="initiate">{__('Initiate')}</MenuItem>
          </Select>
        </FormControl>

        {/* ACCESS */}
        <FormControl className="filter-controls__group" size="small">
          <InputLabel sx={{ fontWeight: 600, color: '#444', fontSize: '0.85rem' }}>{__('ACCESS')}</InputLabel>
          <Select
            value={getValue('access')}
            label={__('ACCESS')}
            onChange={(e) => onFilterClick(e.target.value)}
            sx={{
              fontSize: '0.85rem',
              borderRadius: '6px',
              minWidth: '120px',
              maxWidth: '180px',
              '& .MuiOutlinedInput-notchedOutline': { borderColor: '#ccc' },
              '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#ccc' },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#7f3fbf' },
            }}
          >
            <MenuItem value="accessAll">{__('All')}</MenuItem>
            <MenuItem value="open">{__('Open Access')}</MenuItem>
            <MenuItem value="premium">{__('Premium')}</MenuItem>
          </Select>
        </FormControl>

        {/* YEAR (SAT ONLY) */}
        {isSATMode && (
          <FormControl className="filter-controls__group" size="small">
            <InputLabel sx={{ fontWeight: 600, color: '#444', fontSize: '0.85rem' }}>{__('YEAR')}</InputLabel>
            <Select
              value={selectedYear}
              label={__('YEAR')}
              onChange={(e) => onYearChange(e.target.value)}
              sx={{
                fontSize: '0.85rem',
                borderRadius: '6px',
                '& .MuiOutlinedInput-notchedOutline': { borderColor: '#ccc' },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#ccc' },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#7f3fbf' },
              }}
            >
              <MenuItem value="">{__('All Years')}</MenuItem>
              {availableYears.map((year) => (
                <MenuItem key={year} value={year}>{year}</MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        {/* CLEAR ALL FILTERS BUTTON */}
        <div className="filter-controls__group"
          style = {{
                cursor: 'pointer',
                verticalAlign: 'middle',
                minHeight: '3rem',
          }}
        >
          { 
            filtersAreInUse &&
                <Link
                  href="#"
                  className="filter-controls__clear-button"
                  color="inherit"
                  underline="hover"
                  onClick={(e) => { e.preventDefault(); onFilterClick('clear')}}
                >
                  <CancelIcon style={{ verticalAlign: 'middle', marginRight: '4px' }} />
                  {__('Clear Filters')}
                </Link>
          }
        </div>
      </div>
    </div>
  );
};

export default FilterControls;